import React,{Component} from "react";
import {Text, Button, Group, Paper, Select, Textarea} from '@mantine/core';
import {useNavigate, useParams} from "react-router-dom";
import {getUserDetails} from "../RequestManager";
import {socket} from "../components/Socket";
import {IconCircle, IconCircleCheck, IconSquare, IconSquareCheck} from "@tabler/icons";
import CustomHeader from "../components/CustomHeader";
import PageLoading from "../components/PageLoading";
class AssignmentSubmit extends Component{
    constructor(props) {
        super(props);
        this.state={
            details: undefined,
            isLoading: true,
            isSubmit: false
        }
    }
    componentDidMount() {
        this.getDetails();
        socket.on('success',this.handleSuccess);
        socket.on('failure',this.handleFailure);
    }

    handleSuccess = (data) =>{
        console.log("ass",data)
        switch (data?.type){
            case 'UserAssignAnswers':
                const {details,answers} = data;
                this.setState({details,answers,isLoading: false})
                break;
            case 'SubmitAssignment':
                this.props.navigation('/assignments');
                break;
        }
    }
    handleFailure = (data) =>{
        switch (data?.type){
            case 'UserAssignAnswers':
                this.props.navigation('/assignments');
                break;
            case 'SubmitAssignment':
                this.props.navigation('/assignments');
                break;
        }
    }
    getDetails = () =>{
        const {bookId,id,mobile} = this.props;
        socket.emit('UserAssignAnswers',{bookId,id,mobile});
    }

    handleAnswers = (id,answer) =>{
        let answers =  this.state.answers || {};
        answers[id] = answer || "";
        this.setState({answers});
    }
    submitAnswers = () =>{
        const {answers} = this.state;
        const {bookId,id,mobile} = this.props;
        this.setState({isSubmit: true});
        socket.emit('SubmitAssignment',{bookId,id,mobile,answers});
    }

    render() {
        const {details,answers,isLoading,isSubmit} = this.state;
        return (
            <div>
                <CustomHeader title={"Assignments"} showBackPress={true} backUrl={"/assignments"} />
                {isLoading ? <PageLoading />: <>
                    <Group mx={10} position={'apart'} mb={10} mt={40}>
                        <Text weight={"bold"} mt={10} size={'xl'} align={'center'}>{details?.title}</Text>
                    </Group>
                    {details?.questions?.map(a => <QuestionCard details={a} answer={answers?.[a?.id]} updateValue={this.handleAnswers} />)}
                    <Group position={'center'}>
                        <Button variant={'gradient'} my={10} onClick={this.submitAnswers} loading={isSubmit}>Submit</Button>
                    </Group>
                </>}
            </div>
        );
    }
}
export default function(props){
    const navigation = useNavigate();
    const {bookId,id} = useParams();
    const user = getUserDetails();
    return <AssignmentSubmit bookId={bookId} id={id} navigation={navigation} mobile={user?.mobile} user={user}   {...props} />
};
const QuestionCard = ({details,updateValue,answer}) =>{
    const onValueChange = (ans) => updateValue(details?.id,ans);
    const onCheckBox = (ans) => {
        let array = answer || [];
        array?.includes(ans) ? array = array.filter(a => a != ans) : array.push(ans)
        updateValue(details?.id, array);
    }
    return <Paper shadow={'md'} p={10} mx={10} my={5} withBorder>
                <Text weight={'bold'} size={'md'}>{details?.question}</Text>
                <Text size={'sm'} color={'dimmed'}>{details?.hint}</Text>
                {details?.type === 'textbox' && <Textarea size={'md'} value={answer} onChange={(e) =>onValueChange(e.target.value)} />}
                {details?.type === 'radio' && <Group>{details?.options?.map(a => <Group mx={10} onClick={(e) =>onValueChange(a)}>
                    {answer === a ? <IconCircleCheck />: <IconCircle />}{a}</Group>)}</Group>}
                {details?.type === 'checkbox'&& <Group>{details?.options?.map(a => <Group mx={10} onClick={(e) =>onCheckBox(a)}>
                    {answer?.includes(a) ? <IconSquareCheck/>: <IconSquare />}{a}
                </Group>)}</Group>}
                {details?.type === 'dropDown' &&<Group>
                    <Select size={'md'} data={details?.options?.map(a => ({label: a,value: a}))} onChange={onValueChange} value={answer} />
                </Group>}
        </Paper>
}
